export default __webpack_public_path__ + "static/warriors-e2d163ad46140d0125da3a93b0912106.png";